import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from './features/authentication/AuthenticationSlice';
import navbarReducer from './features/navbar/NavbarSlice';
import documentReducer from './features/dashboard/DocumentSlice';
import documentRequestReducer from './features/dashboard/DocumentRequestSlice';
import archiveReducer from './features/dashboard/ArchiveSlice';
import appointmentReducer from './features/appointment/AppointmentSlice';
import sectionReducer from './features/dashboard/SectionSlice';
import statusReducer from './features/dashboard/DocumentStatusSlice';
import sectionOneReducer from './features/dashboard/SectionOneSlice';
import sectionTwoReducer from './features/dashboard/SectionTwoSlice';
import sectionThreeReducer from './features/dashboard/SectionThreeSlice';
import documentLogRReducer from './features/dashboard/DocumentLogSlice';
import documentTransferReducer from './features/dashboard/DocumentTransferSlice'
import userReducer from './features/dashboard/UserSlice'
import permissionReducer from './features/dashboard/PermissionSlice'
import archiveManagmentReducer from './features/dashboard/ArchiveManagmentSlice'
import statusManagmentReducer from './features/dashboard/StatusManagmentSlice'
import DocumentManagmentReducer from './features/dashboard/DocumentManagmentSlice'
import UserManagmentReducer from './features/dashboard/UserManagmentSlice'
import AgentManagmentReducer from './features/dashboard/AgentManagmentSlice'
import CustomerReducer from './features/dashboard/CustomerSlice'
import FactorReducer from './features/dashboard/FactorSlice'
import AgentRequestReducer from './features/agent/AgentRequestSlice'
import ExhibitionRequestReducer from './features/exhibition/ExhibitionRequestSlice'
import ExhibitionManagmentReducer from './features/dashboard/ExhibitionManagmentSlice'
import DocumentAgentRequestReducer from './features/dashboard/DocumentAgentRequestSlice'


const store = configureStore({
    reducer: {
        authentication: authenticationReducer,
        permission:permissionReducer,
        user: userReducer,
        navbar: navbarReducer,
        document: documentReducer,
        documentRequest: documentRequestReducer,
        archive: archiveReducer,
        appointment: appointmentReducer,
        section: sectionReducer,
        status: statusReducer,
        sectionOne: sectionOneReducer,
        sectionTwo: sectionTwoReducer,
        sectionThree: sectionThreeReducer,
        documentLog: documentLogRReducer,
        documentTransfer: documentTransferReducer,
        archiveManagment: archiveManagmentReducer,
        statusManagment: statusManagmentReducer,
        DocumentManagment: DocumentManagmentReducer,
        userManagment: UserManagmentReducer,
        AgentManagment: AgentManagmentReducer,
        customer: CustomerReducer,
        factor: FactorReducer,
        agentRequest: AgentRequestReducer,
        documentAgentRequest: DocumentAgentRequestReducer,
        ExhibitionRequest: ExhibitionRequestReducer,
        ExhibitionManagment: ExhibitionManagmentReducer,
        
    }
}) 

export default store;